import { ClockCircleOutlined, FileTextOutlined, GiftOutlined, RocketOutlined, ShareAltOutlined, TeamOutlined } from "@ant-design/icons";
import { marketingGroups, marketingPages, marketingPagePermission, type MarketingPageKey } from "./marketing-navigation";

const groupIcons: Record<typeof marketingGroups[number]["key"], React.ReactNode> = {
  marketingContent: <FileTextOutlined />,
  marketingPromotions: <GiftOutlined />,
  marketingCustomers: <TeamOutlined />
};

const icons: Record<MarketingPageKey, React.ReactNode> = {
  marketingLiveCodes: <ShareAltOutlined />,
  growth: <FileTextOutlined />,
  contentXiaohongshu: <FileTextOutlined />,
  contentWechatOfficial: <FileTextOutlined />,
  contentDouyin: <RocketOutlined />,
  contentWechatChannels: <ShareAltOutlined />,
  marketingCampaigns: <RocketOutlined />,
  marketingBenefits: <GiftOutlined />,
  packageDistribution: <ShareAltOutlined />,
  benefitExpiry: <ClockCircleOutlined />
};

export const marketingMenuGroups = () => marketingGroups.map(group => group.key === "marketingContent"
  ? { key: "contentXiaohongshu", label: group.label, permission: marketingPagePermission("contentXiaohongshu"), icon: groupIcons[group.key] }
  : {
    ...group,
    icon: groupIcons[group.key],
    children: marketingPages.filter(page => page.group === group.key).map(page => ({ key: page.key, label: page.title, permission: marketingPagePermission(page.key), icon: icons[page.key] }))
  });
